import { resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, createTextVNode as _createTextVNode, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createBlock as _createBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-3871867d"),n=n(),_popScopeId(),n)
const _hoisted_1 = /*#__PURE__*/_createTextVNode("初中及以下")
const _hoisted_2 = /*#__PURE__*/_createTextVNode("高中、中专")
const _hoisted_3 = /*#__PURE__*/_createTextVNode("大专")
const _hoisted_4 = /*#__PURE__*/_createTextVNode("本科")
const _hoisted_5 = /*#__PURE__*/_createTextVNode("硕士")
const _hoisted_6 = /*#__PURE__*/_createTextVNode("博士")
const _hoisted_7 = /*#__PURE__*/_createTextVNode("MBA/EMBA")
const _hoisted_8 = /*#__PURE__*/_createTextVNode("不限")
const _hoisted_9 = /*#__PURE__*/_createTextVNode("不限")
const _hoisted_10 = /*#__PURE__*/_createTextVNode("在校生")
const _hoisted_11 = /*#__PURE__*/_createTextVNode("应届生")
const _hoisted_12 = /*#__PURE__*/_createTextVNode("1年以内")
const _hoisted_13 = /*#__PURE__*/_createTextVNode("1-3年")
const _hoisted_14 = /*#__PURE__*/_createTextVNode("3-5年")
const _hoisted_15 = /*#__PURE__*/_createTextVNode("5-10年")
const _hoisted_16 = /*#__PURE__*/_createTextVNode("10年以上")
const _hoisted_17 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { style: {"margin-left":"10px","color":"#ccc"} }, "——", -1))
const _hoisted_18 = /*#__PURE__*/_createTextVNode("搜索")
const _hoisted_19 = /*#__PURE__*/_createTextVNode("重置")
const _hoisted_20 = /*#__PURE__*/_createTextVNode("查看")
const _hoisted_21 = /*#__PURE__*/_createTextVNode("删除")
const _hoisted_22 = /*#__PURE__*/_createTextVNode("正常")
const _hoisted_23 = { key: 4 }
const _hoisted_24 = /*#__PURE__*/_createTextVNode("删除")

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_a_input = _resolveComponent("a-input")!
  const _component_a_form_item = _resolveComponent("a-form-item")!
  const _component_a_select_option = _resolveComponent("a-select-option")!
  const _component_a_select = _resolveComponent("a-select")!
  const _component_a_button = _resolveComponent("a-button")!
  const _component_a_form = _resolveComponent("a-form")!
  const _component_a_tooltip = _resolveComponent("a-tooltip")!
  const _component_a_tag = _resolveComponent("a-tag")!
  const _component_a_table = _resolveComponent("a-table")!
  const _component_a_card = _resolveComponent("a-card")!

  return (_openBlock(), _createBlock(_component_a_card, { title: "岗位管理" }, {
    default: _withCtx(() => [
      _createVNode(_component_a_form, {
        autocomplete: "off",
        layout: "inline"
      }, {
        default: _withCtx(() => [
          _createVNode(_component_a_form_item, null, {
            default: _withCtx(() => [
              _createVNode(_component_a_input, {
                placeholder: "岗位名称",
                value: _ctx.searches.name,
                "onUpdate:value": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.searches.name) = $event)),
                style: {"width":"200px"}
              }, null, 8, ["value"])
            ]),
            _: 1
          }),
          _createVNode(_component_a_form_item, null, {
            default: _withCtx(() => [
              _createVNode(_component_a_input, {
                placeholder: "公司名称",
                value: _ctx.searches.shop_name,
                "onUpdate:value": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.searches.shop_name) = $event)),
                style: {"width":"200px"}
              }, null, 8, ["value"])
            ]),
            _: 1
          }),
          _createVNode(_component_a_form_item, null, {
            default: _withCtx(() => [
              _createVNode(_component_a_select, {
                ref: "select",
                value: _ctx.searches.education,
                "onUpdate:value": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.searches.education) = $event)),
                style: {"width":"200px"},
                placeholder: "学历"
              }, {
                default: _withCtx(() => [
                  _createVNode(_component_a_select_option, { value: "1" }, {
                    default: _withCtx(() => [
                      _hoisted_1
                    ]),
                    _: 1
                  }),
                  _createVNode(_component_a_select_option, { value: "2" }, {
                    default: _withCtx(() => [
                      _hoisted_2
                    ]),
                    _: 1
                  }),
                  _createVNode(_component_a_select_option, { value: "3" }, {
                    default: _withCtx(() => [
                      _hoisted_3
                    ]),
                    _: 1
                  }),
                  _createVNode(_component_a_select_option, { value: "4" }, {
                    default: _withCtx(() => [
                      _hoisted_4
                    ]),
                    _: 1
                  }),
                  _createVNode(_component_a_select_option, { value: "5" }, {
                    default: _withCtx(() => [
                      _hoisted_5
                    ]),
                    _: 1
                  }),
                  _createVNode(_component_a_select_option, { value: "6" }, {
                    default: _withCtx(() => [
                      _hoisted_6
                    ]),
                    _: 1
                  }),
                  _createVNode(_component_a_select_option, { value: "7" }, {
                    default: _withCtx(() => [
                      _hoisted_7
                    ]),
                    _: 1
                  }),
                  _createVNode(_component_a_select_option, { value: "0" }, {
                    default: _withCtx(() => [
                      _hoisted_8
                    ]),
                    _: 1
                  })
                ]),
                _: 1
              }, 8, ["value"])
            ]),
            _: 1
          }),
          _createVNode(_component_a_form_item, null, {
            default: _withCtx(() => [
              _createVNode(_component_a_select, {
                ref: "select",
                value: _ctx.searches.working_years,
                "onUpdate:value": _cache[3] || (_cache[3] = ($event: any) => ((_ctx.searches.working_years) = $event)),
                style: {"width":"200px"},
                placeholder: "工作经验"
              }, {
                default: _withCtx(() => [
                  _createVNode(_component_a_select_option, { value: "1" }, {
                    default: _withCtx(() => [
                      _hoisted_9
                    ]),
                    _: 1
                  }),
                  _createVNode(_component_a_select_option, { value: "2" }, {
                    default: _withCtx(() => [
                      _hoisted_10
                    ]),
                    _: 1
                  }),
                  _createVNode(_component_a_select_option, { value: "3" }, {
                    default: _withCtx(() => [
                      _hoisted_11
                    ]),
                    _: 1
                  }),
                  _createVNode(_component_a_select_option, { value: "4" }, {
                    default: _withCtx(() => [
                      _hoisted_12
                    ]),
                    _: 1
                  }),
                  _createVNode(_component_a_select_option, { value: "5" }, {
                    default: _withCtx(() => [
                      _hoisted_13
                    ]),
                    _: 1
                  }),
                  _createVNode(_component_a_select_option, { value: "6" }, {
                    default: _withCtx(() => [
                      _hoisted_14
                    ]),
                    _: 1
                  }),
                  _createVNode(_component_a_select_option, { value: "7" }, {
                    default: _withCtx(() => [
                      _hoisted_15
                    ]),
                    _: 1
                  }),
                  _createVNode(_component_a_select_option, { value: "8" }, {
                    default: _withCtx(() => [
                      _hoisted_16
                    ]),
                    _: 1
                  })
                ]),
                _: 1
              }, 8, ["value"])
            ]),
            _: 1
          }),
          _createVNode(_component_a_form_item, null, {
            default: _withCtx(() => [
              _createVNode(_component_a_input, {
                placeholder: "薪资范围",
                value: _ctx.searches.wages_start,
                "onUpdate:value": _cache[4] || (_cache[4] = ($event: any) => ((_ctx.searches.wages_start) = $event)),
                style: {"width":"200px"}
              }, null, 8, ["value"]),
              _hoisted_17,
              _createVNode(_component_a_input, {
                style: {"width":"200px","margin-left":"10px"},
                placeholder: "薪资范围",
                value: _ctx.searches.wages_end,
                "onUpdate:value": _cache[5] || (_cache[5] = ($event: any) => ((_ctx.searches.wages_end) = $event))
              }, null, 8, ["value"])
            ]),
            _: 1
          }),
          _createVNode(_component_a_form_item, null, {
            default: _withCtx(() => [
              _createVNode(_component_a_button, {
                type: "primary",
                onClick: _ctx.onSearch
              }, {
                default: _withCtx(() => [
                  _hoisted_18
                ]),
                _: 1
              }, 8, ["onClick"])
            ]),
            _: 1
          }),
          _createVNode(_component_a_form_item, null, {
            default: _withCtx(() => [
              _createVNode(_component_a_button, { onClick: _ctx.onReset }, {
                default: _withCtx(() => [
                  _hoisted_19
                ]),
                _: 1
              }, 8, ["onClick"])
            ]),
            _: 1
          })
        ]),
        _: 1
      }),
      _createVNode(_component_a_table, {
        dataSource: _ctx.list,
        columns: _ctx.columns,
        loading: _ctx.loading,
        bordered: "",
        pagination: _ctx.pagination,
        onChange: _ctx.handleTableChange,
        style: {"margin-top":"10px"}
      }, {
        bodyCell: _withCtx(({ column, text, record }) => [
          (column.key === 'wages')
            ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                _createTextVNode(_toDisplayString(record.wages_start) + "——" + _toDisplayString(record.wages_end), 1)
              ], 64))
            : _createCommentVNode("", true),
          (column.key === 'describe')
            ? (_openBlock(), _createBlock(_component_a_tooltip, { key: 1 }, {
                title: _withCtx(() => [
                  _createTextVNode(_toDisplayString(record.describe), 1)
                ]),
                default: _withCtx(() => [
                  _createVNode(_component_a_button, { type: "link" }, {
                    default: _withCtx(() => [
                      _hoisted_20
                    ]),
                    _: 1
                  })
                ]),
                _: 2
              }, 1024))
            : _createCommentVNode("", true),
          (column.key === 'province')
            ? (_openBlock(), _createElementBlock(_Fragment, { key: 2 }, [
                _createTextVNode(_toDisplayString(record.province) + _toDisplayString(record.city) + _toDisplayString(record.area), 1)
              ], 64))
            : _createCommentVNode("", true),
          (column.key === 'del')
            ? (_openBlock(), _createElementBlock(_Fragment, { key: 3 }, [
                (record.del == 1)
                  ? (_openBlock(), _createBlock(_component_a_tag, {
                      key: 0,
                      color: "#f50"
                    }, {
                      default: _withCtx(() => [
                        _hoisted_21
                      ]),
                      _: 1
                    }))
                  : _createCommentVNode("", true),
                (record.del == 0)
                  ? (_openBlock(), _createBlock(_component_a_tag, {
                      key: 1,
                      color: "#2db7f5"
                    }, {
                      default: _withCtx(() => [
                        _hoisted_22
                      ]),
                      _: 1
                    }))
                  : _createCommentVNode("", true)
              ], 64))
            : _createCommentVNode("", true),
          (column.key === 'action')
            ? (_openBlock(), _createElementBlock("div", _hoisted_23, [
                _createVNode(_component_a_button, {
                  size: "small",
                  type: "danger",
                  disabled: record.del == 1,
                  onClick: ($event: any) => (_ctx.onDel(record))
                }, {
                  default: _withCtx(() => [
                    _hoisted_24
                  ]),
                  _: 2
                }, 1032, ["disabled", "onClick"])
              ]))
            : _createCommentVNode("", true)
        ]),
        _: 1
      }, 8, ["dataSource", "columns", "loading", "pagination", "onChange"])
    ]),
    _: 1
  }))
}